import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { config } from "../config/config";

function Footer() {
  const [contactInfo, setContactInfo] = useState({
    email: "info@innobig.com",
    phone: "+88 (017) 1417-0055",
    linkedin_url: "",
    facebook_url: "",
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await fetch(`${config.api.baseURL}/contact/info`);
        if (!response.ok) {
          throw new Error("Failed to load contact info");
        }
        const data = await response.json();
        setContactInfo({
          email: data?.email || "info@innobig.com",
          phone: data?.phone || "+88 (017) 1417-0055",
          linkedin_url: data?.linkedin_url || "",
          facebook_url: data?.facebook_url || "",
        });
      } catch (error) {
        console.error("Error loading contact info:", error);
      }
    };

    fetchContactInfo();
  }, []);

  return (
    <footer className="bg-[#1F3A5F] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4">Innobig</h3>
            <p className="text-[#E5E7EB]">
              Empowering growth through innovation
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/programs"
                  className="text-[#E5E7EB] hover:text-white"
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link
                  to="/corporate-training"
                  className="text-[#E5E7EB] hover:text-white"
                >
                  Corporate Training
                </Link>
              </li>
              <li>
                <Link
                  to="/consulting"
                  className="text-[#E5E7EB] hover:text-white"
                >
                  Consulting
                </Link>
              </li>
              <li>
                <Link
                  to="/coaching"
                  className="text-[#E5E7EB] hover:text-white"
                >
                  Coaching
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-[#E5E7EB] hover:text-white">
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/insights"
                  className="text-[#E5E7EB] hover:text-white"
                >
                  Insights
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#E5E7EB] hover:text-white">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <p className="text-[#E5E7EB]">Email: {contactInfo.email}</p>
            <p className="text-[#E5E7EB]">Phone: {contactInfo.phone}</p>
            <div className="flex space-x-4 mt-4">
              {contactInfo.linkedin_url && (
                <a
                  href={contactInfo.linkedin_url}
                  className="text-[#E5E7EB] hover:text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="sr-only">LinkedIn</span>
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              )}
              {contactInfo.facebook_url && (
                <a
                  href={contactInfo.facebook_url}
                  className="text-[#E5E7EB] hover:text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="sr-only">Facebook</span>
                  <svg
                    className="h-6 w-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
        <div className="border-t border-[#E5E7EB]/30 mt-8 pt-8 text-center text-[#E5E7EB]">
          <p>&copy; {new Date().getFullYear()} Innobig. All rights reserved.</p>
          <div className="mt-2 space-x-4">
            <Link to="/privacy" className="hover:text-white">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white">
              Terms of Service
            </Link>
            <Link to="/refund" className="hover:text-white">
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
